import type { TransactionEvent } from "./screenRenderSpan";

/**
 * Sentry の Inbound Filter「Filter out health check transactions」が末尾一致で見る語
 * （sentry/constants.py の HEALTH_CHECK_GLOBS。`*\/live{/,}` のように末尾スラッシュの有無を問わない）。
 * `*healthcheck*` `*health-check*` `*heartbeat*` は部分一致なので付け足しでは回避できない。ルート名に使わないこと。
 */
const HEALTH_CHECK_TAIL =
  /\/(health|healthy|healthz|health_check|_health|live|livez|ready|readyz|ping|up)\/?$/;

/**
 * transaction 名がフィルタに当たるなら `/index` を足して回避する（URL・routeId は変えない）。
 * Sina では `/_authenticated/live/` と `/_authenticated/call/live/` が該当し、フィルタが ON のプロジェクトでは
 * この 2 画面のトランザクションが Relay で捨てられていた（2026-10-06 確認）。
 */
export const avoidHealthCheckFilter = (
  event: TransactionEvent,
): TransactionEvent => {
  const name = event.transaction;
  if (name && HEALTH_CHECK_TAIL.test(name)) {
    event.transaction = `${name.replace(/\/$/, "")}/index`;
  }
  return event;
};
